import { VideoCreatorApiResponse } from '../api/typings';

export const GET_VIDEO_CREATOR_MY_VIDEO_LIST = 'GET_VIDEO_CREATOR_MY_VIDEO_LIST';
export type GET_VIDEO_CREATOR_MY_VIDEO_LIST = typeof GET_VIDEO_CREATOR_MY_VIDEO_LIST;

export interface GetVideoCreatorMyVideoListAction {
    type: GET_VIDEO_CREATOR_MY_VIDEO_LIST;
    userId: string;
}

export function getVideoCreatorMyVideoList(userId: string): GetVideoCreatorMyVideoListAction {
    return {
        type: GET_VIDEO_CREATOR_MY_VIDEO_LIST,
        userId
    };
}

export const SET_VIDEO_CREATOR_MY_VIDEO_LIST = 'SET_VIDEO_CREATOR_MY_VIDEO_LIST';
export type SET_VIDEO_CREATOR_MY_VIDEO_LIST = typeof SET_VIDEO_CREATOR_MY_VIDEO_LIST;

export interface SetVideoCreatorMyVideoListAction {
    type: SET_VIDEO_CREATOR_MY_VIDEO_LIST;
    videoList: VideoCreatorApiResponse[];
}

export function setVideoCreatorMyVideoList(videoList: VideoCreatorApiResponse[]): SetVideoCreatorMyVideoListAction {
    return {
        type: SET_VIDEO_CREATOR_MY_VIDEO_LIST,
        videoList
    };
}

export const GO_TO_VIDEO_CREATOR_TEMPLATES_LIST_PAGE = 'GO_TO_VIDEO_CREATOR_TEMPLATES_LIST_PAGE';
export type GO_TO_VIDEO_CREATOR_TEMPLATES_LIST_PAGE = typeof GO_TO_VIDEO_CREATOR_TEMPLATES_LIST_PAGE;

export interface GoToVideoCreatorTemplatesListPageAction {
    type: GO_TO_VIDEO_CREATOR_TEMPLATES_LIST_PAGE;
}

export function goToVideoCreatorTemplatesListPage(): GoToVideoCreatorTemplatesListPageAction {
    return {
        type: GO_TO_VIDEO_CREATOR_TEMPLATES_LIST_PAGE
    };
}

export const GO_TO_VIDEO_CREATOR_EDIT_PAGE = 'GO_TO_VIDEO_CREATOR_EDIT_PAGE';
export type GO_TO_VIDEO_CREATOR_EDIT_PAGE = typeof GO_TO_VIDEO_CREATOR_EDIT_PAGE;

export interface GoToVideoCreatorEditPageAction {
    type: GO_TO_VIDEO_CREATOR_EDIT_PAGE;
    videoId: string;
    templateId: string;
}

export function goToVideoCreatorEditPage(videoId: string, templateId: string): GoToVideoCreatorEditPageAction {
    return {
        type: GO_TO_VIDEO_CREATOR_EDIT_PAGE,
        videoId,
        templateId
    };
}

export type VideoCreatorMyVideoListAction =
    | SetVideoCreatorMyVideoListAction
    | GetVideoCreatorMyVideoListAction
    | GoToVideoCreatorEditPageAction
    | GoToVideoCreatorTemplatesListPageAction;
